<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="12" sm="12">
          <div class="allow-title">
            Allocate New Batch to {{ data.selectedUsers.length }} Student(s)
          </div>
        </v-col>

        <v-col cols="12" class="select-enter-batch" sm="6">
          <v-select
            v-model="selectedCenterId"
            :items="data.centers"
            hide-details
            solo
            no-data-text="No centers available"
            label="Choose Center"
            dense
            class="fix-100 ui-multi"
            filled
          ></v-select>
          <InputError :data="error.center" />
        </v-col>

        <v-col cols="12" class="select-enter-batch" sm="6">
          <v-select
            v-model="selectedBatch"
            :items="batches"
            hide-details
            solo
            label="Choose Batch"
            dense
            class="fix-100 ui-multi"
            filled
          ></v-select>
          <InputError :data="error.batch" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <div class="bottom-btn-done">
            <v-btn
              :loading="loading"
              @click="submit"
              class="right-btn cust-btn"
              color="primary"
              >Done</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "BatchAllocationstd",
  props: ["onClose", "data", "status"],
  data() {
    return {
      loading: false,
      batches: [],
      selectedCenterId: null,
      selectedBatch: null,
      error: {
        batch: {
          type: null,
          message: "Please select batch",
        },
        center: {
          type: null,
          message: "Please select center",
        },
      },
    };
  },
  methods: {
    ...mapActions({
      getBatches: "centerAndBatchStore/getBatches",
      allocateBatch: "userStore/allocateBatch",
    }),
    submit() {
      if (this.validate()) {
        let reqData = {
          batch_id: this.selectedBatch,
          user_ids: this.data.selectedUsers,
        };
        this.loading = true;
        this.allocateBatch(reqData)
          .then((response) => {
            this.loading = false;
            this.onClose({ status: false, reload: true });
            this.$toasted.success(`Success\n${response.message}`, {
              icon: "check_circle",
            });
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },
    validate() {
      let isValid = true;
      this.error.center.type = null;
      this.error.batch.type = null;

      if (!this.selectedCenterId) {
        this.error.center.type = "error";
        isValid = false;
      }
      if (!this.selectedBatch) {
        this.error.batch.type = "error";
        isValid = false;
      }
      return isValid;
    },
    onCenterSelect(centerIds) {
      if (centerIds && centerIds.length) {
        this.selectedBatch = null;
        this.$root.showLoader = true;
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            this.$root.showLoader = false;

            if (response && response.list && response.list.length) {
              this.batches = response.list.map((x) => {
                let c = {};
                c.text = x.name;
                c.value = x.id;
                return c;
              });
            } else {
              this.batches = [];
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.batches = [];
      }
    },
  },
  watch: {
    selectedCenterId(val) {
      this.error.center.type = null;
      if (val) {
        this.onCenterSelect([val]);
      }
    },
    selectedBatch(val) {
      this.error.batch.type = null;
    },
    status(val) {
      this.selectedCenterId = null;
      this.selectedBatch = null;
    },
  },
};
</script>
